import { ListPlaceholder, type Props as ListPlaceholderProps } from './components/ListPlaceholder'
import { NoResults as Illustration } from './components/illustrations'

type Props = Omit<ListPlaceholderProps, 'illustration' | 'testId'>

export function NoResults(props: Props) {
  return <ListPlaceholder {...props} testId="list-no-results" illustration={<Illustration />} />
}
